import { OrderCancellationReason } from '@/models/orders.model';
import { IPagination } from '@/models/pagination.model';

export enum CancelledOrdersEndpoints {
  CANCELLED_ORDERS = 'dashboard/cancelled-orders',
  CANCELLED_ORDERS_REASONS = 'dashboard/cancelled-orders/reasons',
  CANCELLED_ORDERS_PARTNERS = 'dashboard/cancelled-orders/partners',
}

export type CancelledOrdersGroupBy = 'day' | 'week' | 'month';

export type DatePresetKey =
  | 'all_time'
  | 'current_year'
  | 'previous_year'
  | 'last_month'
  | 'current_month'
  | 'last_7_days'
  | 'last_30_days'
  | 'custom';

export interface ICancelledOrdersQuery {
  date_from?: string;
  date_to?: string;
  group_by?: CancelledOrdersGroupBy;
}

export interface ICancelledOrdersListQuery extends ICancelledOrdersQuery {
  page?: number;
  per_page?: number;
}

export interface IPeriodRange {
  from: string | null;
  to: string | null;
}

export interface IMetricChange {
  value: number;
  change_percent: number | null;
}

export interface IShareMetricChange {
  value: number;
  change_pp: number | null;
}

export interface ICancelledOrdersKpis {
  cancelled_count: IMetricChange;
  cancelled_amount: IMetricChange;
  cancelled_avg_check: IMetricChange;
  cancelled_share_percent: IShareMetricChange;
}

export interface ICancelledOrdersSeriesItem {
  date: string;
  confirmed_amount: number;
  cancelled_amount: number;
  confirmed_count: number;
  cancelled_count: number;
  confirmed_share_percent: number;
  cancelled_share_percent: number;
}

export interface ICancelledOrdersTotals {
  confirmed_amount: number;
  cancelled_amount: number;
  confirmed_count: number;
  cancelled_count: number;
  cancelled_share_percent: number;
}

export interface ICancelledReasonItem {
  code: OrderCancellationReason | string;
  label: string | null;
  share_percent: number;
  change_percent: number | null;
  count?: number;
}

export interface ICancelledPartnerItem {
  id: string;
  name: string;
  cancelled_share_percent: number;
  change_percent: number | null;
  cancelled_count?: number;
}

export interface ICancelledOrdersData {
  period: IPeriodRange;
  previous_period: IPeriodRange | null;
  kpis: ICancelledOrdersKpis;
  series: ICancelledOrdersSeriesItem[];
  totals: ICancelledOrdersTotals;
  reasons: ICancelledReasonItem[];
  partners: ICancelledPartnerItem[];
}

export interface IGetCancelledOrdersResponse {
  data: ICancelledOrdersData;
}

export interface IGetCancelledReasonsResponse {
  data: ICancelledReasonItem[];
  meta: IPagination;
}

export interface IGetCancelledPartnersResponse {
  data: ICancelledPartnerItem[];
  meta: IPagination;
}
